<!-- <div style="display: flex;flex-direction: row;justify-content: center;">
  <div class="legendLabel" *ngFor="let legend of legendValue"  >
        <div class="lName">
          <span  > {{ legend.name }}</span></div>
        <div  class="key-dot" [style.background]="legend.color"></div>
  </div>
</div> -->
<svg style="display: none;">
  <symbol id="arrow-icon-symbol" viewBox="0 0 12 12">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M2.01176 1.94274C1.83391 1.94274 1.66335 2.01339 1.53759 2.13915C1.41183 2.26491 1.34118 2.43548 1.34118 2.61333V9.9898C1.34118 10.1676 1.41183 10.3382 1.53759 10.464C1.66335 10.5897 1.83391 10.6604 2.01176 10.6604H9.38823C9.56608 10.6604 9.73665 10.5897 9.86241 10.464C9.98817 10.3382 10.0588 10.1676 10.0588 9.9898V6.60156C10.0588 6.23121 10.3591 5.93097 10.7294 5.93097C11.0998 5.93097 11.4 6.23121 11.4 6.60156V9.9898C11.4 10.5234 11.188 11.035 10.8108 11.4123C10.4335 11.7896 9.92179 12.0016 9.38823 12.0016H2.01176C1.47821 12.0016 0.966511 11.7896 0.589232 11.4123C0.211953 11.035 0 10.5233 0 9.9898V2.61333C0 2.07977 0.211953 1.56807 0.589232 1.19079C0.966511 0.813516 1.47821 0.601562 2.01176 0.601562H5.32941C5.69977 0.601562 6 0.901795 6 1.27215C6 1.64251 5.69977 1.94274 5.32941 1.94274L2.01176 1.94274Z"
      fill="#1363DF" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M7.20001 0.6C7.20001 0.268629 7.46864 0 7.80001 0H11.4C11.7314 0 12 0.268629 12 0.6V4.2C12 4.53137 11.7314 4.8 11.4 4.8C11.0686 4.8 10.8 4.53137 10.8 4.2V1.2H7.80001C7.46864 1.2 7.20001 0.931371 7.20001 0.6Z"
      fill="#1363DF" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M11.8243 0.175736C12.0586 0.410051 12.0586 0.78995 11.8243 1.02426L5.22428 7.62426C4.98996 7.85858 4.61006 7.85858 4.37575 7.62426C4.14143 7.38995 4.14143 7.01005 4.37575 6.77574L10.9757 0.175736C11.2101 -0.0585787 11.59 -0.0585787 11.8243 0.175736Z"
      fill="#1363DF" />
  </symbol>
</svg>
<!-- legend -->
<div id="legendDiv" style="width: 100%;display: flex;justify-content: center;margin: 10px 0px 5px 0px;"></div>

<!-- chart container -->
<div style="height: 100%; overflow-x:auto;" id='heatmapContainer' #heatmapContainer></div>
<!-- <div style="display: flex;">
    <div id="Yaxis"></div>
<div  id='heatmapContainer' style="overflow:auto ;"></div></div> -->

<!-- Tooltip -->
<div id="ItSummeryTooltip">
  <div class="container chart_tooltip" *ngIf="this.tooltipVisible">
    <div class="row chart_tooltip_header ">
      <div class="col-12 chart_tooltip_header_data mt-1 mb-1">
        {{ mytooltipData?.source_name + ' / ' }}{{ mytooltipData?.period | date: 'dd MMM yyyy'}}
      </div>
    </div>

    <div class="mt-1 mb-5 pb-2" [ngClass]="(dataTurn < 250) ? 'chart_tooltip_body-after' :'chart_tooltip_body'">
      <div *ngIf="!scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="'#1363DF'">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2"> DISPENSE FROM INVENTORY : {{mytooltipData?.inventory_qty ?
            numbedPipe(mytooltipData?.inventory_qty) : 0 }}
          </div>

          <div class="ml-2">
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousMA == 'up'" />

            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousMA == 'down'" />
          </div>

        </div>
      </div>
      <div *ngIf="!scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="'#EF933E'">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2"> DISPENSE FROM SHIPMENT : {{mytooltipData?.dispense_qty ?
            numbedPipe(mytooltipData?.dispense_qty) : 0 }}
          </div>

          <div class="ml-2">
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'up'" />
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'down'" />
          </div>
        </div>
      </div>
      <div *ngIf="!scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="'red'">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2"> DIFFERENCE : {{mytooltipData?.qty_difference ?
            numbedPipe(mytooltipData?.qty_difference)+'('+ math.abs(mytooltipData?.pct_difference) + '%)' :
            numbedPipe(mytooltipData?.qty_difference)+'('+ math.abs(mytooltipData?.pct_difference) + '%)' }}
          </div>

          <div class="ml-2">
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'up'" />
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'down'" />
          </div>
        </div>
      </div>
      <div *ngIf="!scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="'gray'">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2"> INVENTORY ON HAND : {{mytooltipData?.inventory_on_hand ?
            numbedPipe(mytooltipData?.inventory_on_hand) : 0 }}
          </div>

          <div class="ml-2">
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'up'" />
            <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
              *ngIf="mytooltipData.comparedToPreviousQS == 'down'" />
          </div>
        </div>
      </div>
      <div *ngIf="scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="mytooltipData?.color">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2 scatter_tooltip"> {{mytooltipData?.kpi_nm}}
            <p class="mb-1">{{mytooltipData?.kpi_value}}</p>
          </div>
        </div>
      </div>
      <div *ngIf="scatter && (mytooltipData?.lower_threshold && mytooltipData?.upper_threshold)" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="'blue'">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2 scatter_tooltip"> Thresholds
            <p class="mb-1">-</p>
          </div>
        </div>
      </div>
      <div *ngIf="scatter" class="row">
        <div class="col-12 d-flex m-auto  align-items-center">
          <div>
            <div class="tooltip_outlay darken" [style.background]="mytooltipData?.color">
            </div>
          </div>
          <div class="chart_tooltip_body_data ml-2 scatter_tooltip"> Control limits
            <p class="mb-1">{{mytooltipData.lower_control_limit.toFixed(2)}} -
              {{mytooltipData.upper_control_limit.toFixed(2)}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="SimpleTooltip" [style.visibility]="simpleTooltipVisible ? 'visible' : 'hidden'">
  {{simpleTooltipText}}
</div>